import { render, staticRenderFns } from "./BsNotificationBar.vue?vue&type=template&id=0098af99&scoped=true&"
import script from "./BsNotificationBar.vue?vue&type=script&lang=js&"
export * from "./BsNotificationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098af99",
  null
  
)

export default component.exports